import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";
import { EPP_LOGO, navItems, contactInfo } from "../../data/content";
import { WIDE_CONTENT_WRAP } from "../../constants/layout";
import { useCookieConsent } from "../../context/CookieConsentContext";

export const Footer = () => {
  const { openPreferences } = useCookieConsent();
  return (
  <footer className="bg-[#041852] text-white" data-testid="footer">
    <div className="flex h-2 w-full shrink-0" aria-hidden="true">
      <div className="flex-1 bg-[#002395]" />
      <div className="flex-1 bg-[#f5f5f5]" />
      <div className="flex-1 bg-[#ED2939]" />
    </div>
    <div className={WIDE_CONTENT_WRAP}>
    <div className="py-14 md:py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
        <div className="sm:col-span-2 lg:col-span-1">
          <Link to="/" className="inline-block mb-5">
            <img src={EPP_LOGO} alt="Euro Plomberie Piscines" className="h-16 md:h-20 w-auto brightness-200 opacity-95 hover:opacity-100 transition-opacity" />
          </Link>
          <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
            Votre expert en plomberie, chauffage, climatisation et piscines. 5 agences de retrait et un showroom sur la Côte d'Azur depuis plus de 25 ans.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4 text-[#F2B531]">Nos services</h4>
          <ul className="space-y-2.5">
            {navItems.filter((i) => i.path !== "/" && i.path !== "/contact").slice(0, 6).map((item) => (
              <li key={item.path}>
                <Link to={item.path} className="text-gray-400 hover:text-white text-sm transition-colors">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4 text-[#F2B531]">Navigation</h4>
          <ul className="space-y-2.5">
            <li><Link to="/" className="text-gray-400 hover:text-white text-sm transition-colors">Accueil</Link></li>
            <li><Link to="/showroom" className="text-gray-400 hover:text-white text-sm transition-colors">Showroom</Link></li>
            <li><Link to="/evenements" className="text-gray-400 hover:text-white text-sm transition-colors">Événements</Link></li>
            <li><Link to="/promos" className="text-gray-400 hover:text-white text-sm transition-colors">Promotions</Link></li>
            <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4 text-[#F2B531]">Contact</h4>
          <ul className="space-y-3.5 text-sm text-gray-400">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#F2B531] flex-shrink-0" />
              <span className="leading-relaxed">{contactInfo.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#F2B531] flex-shrink-0" />
              <a href={`tel:${contactInfo.phone1.replace(/\s/g, "")}`} className="hover:text-white transition-colors">{contactInfo.phone1}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#F2B531] flex-shrink-0" />
              <a href={`mailto:${contactInfo.email}`} className="hover:text-white transition-colors break-all">{contactInfo.email}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 pb-20 sm:pb-24">
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-gray-400 sm:text-sm">
        <Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
        <span className="text-white/20" aria-hidden>|</span>
        <Link to="/politique-confidentialite" className="hover:text-white transition-colors">Confidentialité</Link>
        <span className="text-white/20" aria-hidden>|</span>
        <Link to="/politique-cookies" className="hover:text-white transition-colors">Cookies</Link>
        <span className="text-white/20" aria-hidden>|</span>
        <Link to="/cgv" className="hover:text-white transition-colors">CGV</Link>
        <span className="text-white/20" aria-hidden>|</span>
        <Link to="/cgu" className="hover:text-white transition-colors">CGU</Link>
        <span className="text-white/20" aria-hidden>|</span>
        <button
          type="button"
          onClick={openPreferences}
          className="hover:text-white transition-colors underline-offset-2 hover:underline"
        >
          Gérer mes cookies
        </button>
      </div>
      <p className="mt-4 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} Euro Plomberie Piscines — Tous droits réservés
      </p>
    </div>
    </div>
  </footer>
  );
};
